module.exports = __webpack_public_path__ + "static/media/btslogo2.94f907ff.webp";